// Обращения сотрудников: «Информация неверна» и «Сообщить в IT» — чистые функции (решение Анны 04.11.2026). [Claude]
export const KIND_INACCURACY = 'inaccuracy'
export const KIND_SUPPORT = 'support'
export const COMMENT_MIN = 3
export const COMMENT_MAX = 4000
export const CONTEXT_MAX = 8000

const LIMITS = { page: 500, section: 64, objectType: 32, objectId: 64, tripNumber: 32 }

function clip(value, max) {
  if (value === null || value === undefined) return null
  const text = String(value).trim()
  return text ? text.slice(0, max) : null
}

export function validateFeedback(comment) {
  const text = String(comment ?? '').trim()
  if (text.length < COMMENT_MIN) return { ok: false, error: 'Опишите своими словами, что не так' }
  return { ok: true, comment: text.slice(0, COMMENT_MAX) }
}

// Снимок того, что человек видел на экране: только данные, без функций и циклов; большой — обрезаем.
export function sanitizeContext(context) {
  if (context === null || context === undefined || context === '') return null
  let json
  try {
    json = JSON.stringify(context)
  } catch (e) {
    return { text: String(context).slice(0, CONTEXT_MAX) }
  }
  if (json === undefined) return null
  if (json.length > CONTEXT_MAX) return { truncated: json.slice(0, CONTEXT_MAX) }
  return JSON.parse(json)
}

export function buildFeedbackPayload({ kind, comment, page, section, objectType, objectId, tripNumber, context }) {
  return {
    kind: kind === KIND_SUPPORT ? KIND_SUPPORT : KIND_INACCURACY,
    comment: String(comment ?? '').trim().slice(0, COMMENT_MAX),
    page: clip(page, LIMITS.page),
    section: clip(section, LIMITS.section),
    object_type: clip(objectType, LIMITS.objectType),
    object_id: clip(objectId, LIMITS.objectId),
    trip_number: clip(tripNumber, LIMITS.tripNumber),
    context: sanitizeContext(context),
  }
}

export function savedText(item) {
  const number = item && item.id ? ` №${item.id}` : ''
  return `Записано, обращение${number}. Руководитель или юрист разберёт его и ответит.`
}

export function errorText(error) {
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string' && detail) return detail
  return 'Не удалось записать обращение. Проверьте связь и попробуйте ещё раз.'
}
